import { Component, computed, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FavouriteCurrencyMode, FavouriteCurrencyType } from '../../../models/filter-models';
import { AutocompleteComponent, AutocompleteOption } from '../../../common/autocomplete/autocomplete.component';
import { SelectComponent, SelectOptionComponent } from '../../../common/select/select.component';
import { BaseComponent } from '../../../common/base.component';
import { poe1 } from '../../../../game';
import { confirmRemove } from '../../../common/confirm-remove';

@Component({
  selector: 'app-favourite-currency-type-filter',
  imports: [FormsModule, AutocompleteComponent, SelectComponent, SelectOptionComponent],
  templateUrl: './favourite-currency-type-filter.component.html',
  styleUrl: './favourite-currency-type-filter.component.scss'
})
export class FavouriteCurrencyTypeFilterComponent extends BaseComponent {
  entry = input.required<FavouriteCurrencyType>();
  index = input.required<number>();
  itemTypeOptions = input<AutocompleteOption[]>([]);

  remove = output<number>();
  changed = output<void>();

  FavouriteCurrencyMode = FavouriteCurrencyMode;

  isRowInactive = (): boolean => !(this.entry().enabled ?? false);

  showGoldenBorder = computed(() => !!this.entry().fromPresets);

  onModeChanged(mode: FavouriteCurrencyMode) {
    const entry = this.entry();
    entry.mode = mode;
    if (mode === FavouriteCurrencyMode.PromoteTier) {
      entry.value = 1;
    } else if (mode === FavouriteCurrencyMode.Multiplier) {
      entry.value = poe1 ? 1.5 : 2;
    } else {
      entry.value = null;
    }
    this.changed.emit();
  }

  onEnabledToggled() {
    this.entry().enabled = !this.entry().enabled;
    this.changed.emit();
  }

  onItemTypesChanged(values: string[]) {
    this.entry().itemTypes = values;
    this.changed.emit();
  }

  onValueInputChanged(newValue: number | null) {
    this.entry().value = newValue;
    this.changed.emit();
  }

  removeEntry() {
    if (!confirmRemove('Are you sure you want to remove this Favourite Currency Type?')) return;
    this.remove.emit(this.index());
  }
}
